module.exports = __webpack_public_path__ + "img/P55-en.f3ef9bbb.png";